<template>
  <section>
    <div class="primary-header">
      <h1 data-qa="Content-Export-Title">
        {{ componentTitle }}
        <small>{{ $route.meta.description }}</small>
      </h1>
    </div>
    <div>
      <el-date-picker
        :picker-options="pickerOptions"
        @change="onPickerChange(dateRange)"
        end-placeholder="End Date"
        start-placeholder="Start Date"
        type="daterange"
        v-model="dateRange"
      ></el-date-picker>
      <el-button
        :disabled="isExportDisabled"
        @click="exportData(dateRange)"
        type="warning"
      >{{ $t('exportButton') }}</el-button>
    </div>
    <div class="help is-danger">{{ error }}</div>
  </section>
</template>

<script>
  import main from './Export.js'
  export default main
</script>

<style lang="scss" scoped>
  @import './Export.scss'
</style>



// WEBPACK FOOTER //
// Export.vue?7dbacdb3